/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetExistingUserResponse
 */
export interface GetExistingUserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetExistingUserResponse
     */
    _exists?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetExistingUserResponse
     */
    disabled?: boolean;
}

/**
 * Check if a given object implements the GetExistingUserResponse interface.
 */
export function instanceOfGetExistingUserResponse(value: object): value is GetExistingUserResponse {
    return true;
}

export function GetExistingUserResponseFromJSON(json: any): GetExistingUserResponse {
    return GetExistingUserResponseFromJSONTyped(json, false);
}

export function GetExistingUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExistingUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        '_exists': json['exists'] == null ? undefined : json['exists'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
    };
}

export function GetExistingUserResponseToJSON(json: any): GetExistingUserResponse {
    return GetExistingUserResponseToJSONTyped(json, false);
}

export function GetExistingUserResponseToJSONTyped(value?: GetExistingUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exists': value['_exists'],
        'disabled': value['disabled'],
    };
}

